import React, { useEffect, useRef } from "react";
import { T_LeadsNature } from "../../../types";
import { useAuth0 } from "@auth0/auth0-react";

interface Props {
  leadContent: T_LeadsNature;
  dismissAction: (id: string) => void;
}

export let LeadsNurture = ({ leadContent, dismissAction }: Props) => {
  const { isAuthenticated } = useAuth0();
  const isBottom = leadContent.alignment === "Bottom";
  const isDiscover = leadContent.alignment === "Discover";

  useEffect(() => {
    if (isDiscover && leadContent?.scope === "loggedIn" && !isAuthenticated)
      return;
    if (isDiscover && leadContent?.scope === "loggedOut" && isAuthenticated)
      return;
    if (!leadContent.htmlInput) return;

    // Inject style
    const styleMatch = leadContent.htmlInput.match(
      /<style[^>]*>([\s\S]*?)<\/style>/i
    );
    if (styleMatch) {
      const styleTag = document.createElement("style");
      styleTag.innerHTML = styleMatch[1];
      document.head.appendChild(styleTag);

      return () => {
        document.head.removeChild(styleTag);
      };
    }
  }, [leadContent.htmlInput]);

  const cleanHtml = leadContent.htmlInput
    ?.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
    .replace(/<meta[^>]*>/gi, "");

  const containerRef = useRef<HTMLDivElement>(null);

useEffect(() => {
  if (!containerRef.current) return;

  const formEl = containerRef.current.querySelector('form') as HTMLFormElement | null;
  const messageEl = containerRef.current.querySelector('#form-message') as HTMLDivElement | null;
  const closeBtn = containerRef.current.querySelector('.close-modal') as HTMLButtonElement | null;

  if (!formEl) return;

  const handleSubmit = (e: Event) => {
    e.preventDefault();

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.name = 'hiddenFrame_' + Date.now();
    document.body.appendChild(iframe);

    formEl.target = iframe.name;
    formEl.submit();

    if (messageEl) messageEl.style.display = 'block';

    setTimeout(() => formEl.reset(), 100);
    setTimeout(() => {
      if (messageEl) messageEl.style.display = 'none';
    }, 2000);

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 5000);

    // Close popup a bit later (e.g., after 3 seconds)
      setTimeout(() => {
        if (leadContent?.alignment === 'Pop-Up') {
          dismissAction(leadContent.id);
        }
      }, 3000);

  };

  const handleClose = () => {
    // Close popup immediately
    if (leadContent?.alignment === "Pop-Up") {
      dismissAction(leadContent.id);
    }
  };

  formEl.addEventListener('submit', handleSubmit);
  if (closeBtn) closeBtn.addEventListener('click', handleClose);

  return () => {
    formEl.removeEventListener('submit', handleSubmit);
    if (closeBtn) closeBtn.removeEventListener('click', handleClose);
  };
}, [leadContent, dismissAction]);



  return (
    <>
      {isBottom || isDiscover ? (
        // Bottom sticky style
        <div ref={containerRef}>
          <div dangerouslySetInnerHTML={{ __html: cleanHtml || "" }} />
        </div>
      ) : (
        // Fullscreen modal style
        <div
          ref={containerRef}
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
        >
          <div dangerouslySetInnerHTML={{ __html: cleanHtml || "" }} />
        </div>
      )}
    </>
  );
};
